<script>

    import { markRaw } from 'vue';

    import MixinList from '@/Libs/Mixins/ListTab.js';

    import RoomFormSidebar from '../Part/RoomFormSidebar.vue';

    export default {
        mixins: [MixinList],
        props: {
            branch: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                roomFormSidebar: markRaw(RoomFormSidebar),

                routeName: 'branch-detail',
                tabName: 'room'
            }
        },
        methods: {
            async _search(search) {
                search.order_by = 'name';
                search.sort_by = 'asc';

                return await this.$api.Room.all(search);
            },
            // ======
            doSearch() {
                if (this.search.order_by)
                    this.search.order_by = this.$orderBy.toString();

                this.$router.replace({ name: 'branch-detail', params: { id: this.$route.params.id }, query: this.search });
            },
            _beforeSearch(search) {
                var vm = this;

                search.branch_id = vm.$route.params.id;

                delete search.tabIndex;

                return search;
            },
            onRefreshRoom() {
                var vm = this;

                vm._doSearch();
            }
        }
    };
</script>

<template>
    <BRow class="g-4 align-items-center mb-3">
        <BCol sm="auto">
            <div class="d-flex flex-wrap align-items-start gap-2">
                <btn-sidebar variant="success"
                    v-if="$ac.hasAccess('room_full_access') || ($ac.hasAccess('room_create') && $ac.hasAccessStore(branch.store_id))"
                    :sidebar="roomFormSidebar" :data="{ branch: branch }" :success="onRefreshRoom">
                    <i class="mdi mdi-plus-thick align-bottom me-1"></i> {{ $t('basic.btn.add') }}
                </btn-sidebar>
                <BButton type="button" variant="info"
                    @click="$router.push({ name: 'room', query: { branch_id: branch.id } })"
                    v-if="$ac.hasAccess('room_full_access') || ($ac.hasAccess('room_list') && ($ac.hasAccessStore(branch.store_id) || $ac.hasAccessBranch(branch.id)))">
                    <i class="mdi mdi-format-list-text align-bottom me-1"></i> {{ $t('basic.btn.more') }}
                </BButton>
            </div>
        </BCol>
        <BCol sm>
            <div class="d-flex justify-content-sm-end">
                <div class="search-box ms-2">
                    <b-form @submit="doSearch()">
                        <input type="text" class="form-control" v-model="search.keyword"
                            :placeholder="$t('filter.placeholder.keyword')" />
                        <i class="mdi mdi-magnify search-icon"></i>
                    </b-form>
                </div>
            </div>
        </BCol>
    </BRow>
    <BRow>
        <BCol lg="12">
            <div class="table-responsive">
                <loading :loading="$loading.get([routeName, tabName, 'list'].join('_'))" variant="dark" type="block">
                    <BListGroup tag="ul" class="mb-1">
                        <BListGroupItem tag="li" v-for="(tr, index) in list" :key="index" @click="($ac.hasAccess('room_full_access') || ($ac.hasAccess('room_show') && ($ac.hasAccessStore(branch.store_id)))) &&
                            ($router.push({ name: 'room-detail', params: { id: tr.id } }))" :class="[
                                ($ac.hasAccess('room_full_access') || ($ac.hasAccess('room_show') && ($ac.hasAccessStore(tr.store_id)))) ? 'cursor-pointer' : ''
                            ]">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center flex-grow-1">
                                    <div class="flex-shrink-0 avatar-xs">
                                        <div class="avatar-title rounded text-dark bg-light">
                                            <i class="mdi mdi-view-quilt-outline fs-4"></i>
                                        </div>
                                    </div>
                                    <div class="ms-3">
                                        <h6 class="mb-0">{{ tr.name }}</h6>
                                        <small class="text-muted d-block">{{ tr.ref_no }}</small>
                                    </div>
                                </div>
                            </div>
                        </BListGroupItem>
                    </BListGroup>
                </loading>
            </div>
        </BCol>
    </BRow>

    <BRow class="g-0 justify-content-end mb-4" id="pagination-element">
        <BCol sm="6">
            <pagination v-bind:model="paginator" v-on:goto="goto"
                :disabled="$loading.get([routeName, 'list'].join('_'))" />
        </BCol>
    </BRow>
</template>